// File: TabulatorSettings.js

import React, { useState } from "react";

export default function TabulatorSettings() {
  const [tabulatorConfig, setTabulatorConfig] = useState({
    defaultCompetitionId: "PHX_MAIN_S1",
    layoutMode: "grid", // or "list"
    autoScroll: false,
    // add other relevant fields as needed
  });

  const handleChange = (field, value) => {
    setTabulatorConfig((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-8">
      <h1 className="text-2xl font-bold">Tabulator Settings</h1>
      <p className="text-sm text-gray-600 mb-4">
        Control how the tabulator console behaves (layout, default competition ID, etc.).
      </p>

      <div className="bg-white p-4 rounded border border-gray-200 space-y-4">
        {/* Default Competition ID */}
        <div>
          <label className="block font-medium mb-1">Default Competition ID</label>
          <input
            type="text"
            value={tabulatorConfig.defaultCompetitionId}
            onChange={(e) => handleChange("defaultCompetitionId", e.target.value)}
            className="border-b w-full focus:outline-none p-1"
          />
          <p className="text-xs text-gray-500 mt-1">
            The default ID to use when loading Tabulator if none is specified.
          </p>
        </div>

        {/* Layout Mode */}
        <div>
          <label className="block font-medium mb-1">Layout Mode</label>
          <select
            value={tabulatorConfig.layoutMode}
            onChange={(e) => handleChange("layoutMode", e.target.value)}
            className="border-b w-full focus:outline-none p-1"
          >
            <option value="grid">Grid</option>
            <option value="list">List</option>
          </select>
          <p className="text-xs text-gray-500 mt-1">
            Choose how routines / score panels are laid out in the tabulator console.
          </p>
        </div>

        {/* Auto-scroll Toggle */}
        <div className="flex items-center gap-3">
          <input
            id="autoScroll"
            type="checkbox"
            checked={tabulatorConfig.autoScroll}
            onChange={(e) => handleChange("autoScroll", e.target.checked)}
            className="h-4 w-4"
          />
          <label htmlFor="autoScroll" className="font-medium">
            Auto-scroll schedule as new routines become current?
          </label>
        </div>
      </div>
    </div>
  );
}
